$(document).on("turbolinks:load", () => {
    $(window).on("scroll", function() {
        var scroll = $(window).scrollTop();
        if( 30 < scroll ){
            $('#page_top').fadeIn();

        } else {
            $('#page_top').fadeOut();
        }
    });
    $('#page_top div').click(function(){
        $('body,html').animate({
            scrollTop: 0},500);
        return false;
    });
})